<div class="title" mat-dialog-title>{{ 'SMS_REGISTRATION.LEARN_MORE_MODAL.TITLE' | translate }}</div>
<mat-dialog-content>
  @switch (registrationType$ | async) {
    @case (RegistrationType.A2P_REGISTRATION) {
      <div>
        <b>SMS Registration Requirements</b>
        <p>
          To prevent spam and other SMS abuse, phone carriers in the United States now require businesses to register
          their phone numbers before sending SMS messages to customers. (Policy known as A2P 10DLC)
        </p>
        <b>How long does registration take?</b>
        <p>
          Once the form has been submitted, registration through third-party verification can take anywhere from one
          week, up to one month. A third-party agency is being used by telecom carriers in the United States to verify
          business registration data with government databases.
        </p>
        <b>How will I know when my registration is approved?</b>
        <p>
          You will receive an email notification when your registration is approved, as long as instant email
          notifications are enabled in your notification settings. There is no need to check the dashboard daily.
        </p>
        <b>How do I find my business registration number a.k.a. EIN / Tax ID?</b>
        <p>
          An EIN is a nine-digit number the IRS uses to identify a business for tax purposes, much like a Social
          Security number identifies an individual business. In the US, the Internal Revenue Service (IRS) issues a CP
          575 EIN Confirmation Letter to confirm the unique Employer Identification Number (EIN) issued to a new
          business. The EIN provided in a CP 575 letter is required to file your company's taxes, open a business bank
          account, and apply for a business credit card, loan, or payroll processing. You may be able to find your
          number on previous business tax returns, loans, licenses or bank statements. If you can't find your EIN on any
          of your documents, you can contact the IRS at 800-829-4933, Monday through Friday between 7 a.m. and 7 p.m.
          local time. If your business does not have an EIN, you can apply for an EIN by submitting IRS Form SS-4 with
          the IRS.
        </p>
        <b>How can I ensure my application is approved?</b>
        <p>
          Make sure the data entered exactly matches the information associated with your EIN, including your legal
          company name. The most common reason for a business's application being rejected is because the information
          entered in the form does not match the information the IRS has for the business, associated with your EIN.
        </p>
        <b>What if my business deals with age-restricted products?</b>
        <p>
          We do not handle age verification laws and associated requirements for SMS messaging. Consequently, industries
          related to age-restricted products, such as alcohol, firearms, gambling, tobacco, and other adult content, are
          not supported at this time.
        </p>
        <b>What are prohibited uses and restricted industries?</b>
        <p>
          Certain messaging use cases are strictly prohibited to ensure compliance with regulations and carrier
          requirements. The following categories of businesses cannot register for A2P messaging:
        </p>
        <ul>
          <li>High-risk financial services (e.g., payday loans, short-term high-interest loans, cryptocurrency)</li>
          <li>Third-party lead generation and marketing (e.g., affiliate marketing, deceptive practices)</li>
          <li>Debt collection or forgiveness services</li>
          <li>"Get rich quick" schemes (e.g., pyramid schemes, deceptive work-from-home opportunities)</li>
          <li>Illegal substances or articles (e.g., cannabis, CBD, kratom, paraphernalia products)</li>
          <li>Prescription drugs (e.g., drugs requiring a prescription)</li>
          <li>Gambling (e.g., casino apps, betting/sports picks, sweepstakes)</li>
          <li>Age-restricted content (e.g., alcohol, firearms, tobacco, vape/e-cigs)</li>
        </ul>
        <p>
          These restrictions apply regardless of the content of the message. If your business operates within these
          categories, it will not be supported for A2P registration on our platform.
        </p>
      </div>
    }
    @case (RegistrationType.REGULATORY_COMPLIANCE) {
      <div>
        <b>{{ 'SMS_REGISTRATION.LEARN_MORE_MODAL.REGULATORY_COMPLIANCE.TITLE' | translate }}</b>
        <p>
          {{ 'SMS_REGISTRATION.LEARN_MORE_MODAL.REGULATORY_COMPLIANCE.INTRO' | translate }}
        </p>
        <b>{{ 'SMS_REGISTRATION.LEARN_MORE_MODAL.REGULATORY_COMPLIANCE.INFORMATION_REQUIRED_TITLE' | translate }}</b>
        <p>
          {{ 'SMS_REGISTRATION.LEARN_MORE_MODAL.REGULATORY_COMPLIANCE.INFORMATION_REQUIRED_TEXT' | translate }}
        </p>
        <b>{{ 'SMS_REGISTRATION.LEARN_MORE_MODAL.REGULATORY_COMPLIANCE.PROCESSING_TIME_TITLE' | translate }}</b>
        <p>
          {{ 'SMS_REGISTRATION.LEARN_MORE_MODAL.REGULATORY_COMPLIANCE.PROCESSING_TIME_TEXT' | translate }}
        </p>
        <b>{{ 'SMS_REGISTRATION.LEARN_MORE_MODAL.REGULATORY_COMPLIANCE.REQUIRED_DOCUMENTATION_TITLE' | translate }}</b>
        <p>
          {{ 'SMS_REGISTRATION.LEARN_MORE_MODAL.REGULATORY_COMPLIANCE.REQUIRED_DOCUMENTATION_TEXT' | translate }}
        </p>
        <ul>
          <li>
            {{
              'SMS_REGISTRATION.LEARN_MORE_MODAL.REGULATORY_COMPLIANCE.REQUIRED_DOCUMENTS.BUSINESS_REGISTRATION'
                | translate
            }}
          </li>
          <li>
            {{
              'SMS_REGISTRATION.LEARN_MORE_MODAL.REGULATORY_COMPLIANCE.REQUIRED_DOCUMENTS.TAX_IDENTIFICATION'
                | translate
            }}
          </li>
          <li>
            {{
              'SMS_REGISTRATION.LEARN_MORE_MODAL.REGULATORY_COMPLIANCE.REQUIRED_DOCUMENTS.PROOF_OF_ADDRESS' | translate
            }}
          </li>
          <li>
            {{
              'SMS_REGISTRATION.LEARN_MORE_MODAL.REGULATORY_COMPLIANCE.REQUIRED_DOCUMENTS.REPRESENTATIVE_ID' | translate
            }}
          </li>
        </ul>
        <p>
          {{ 'SMS_REGISTRATION.LEARN_MORE_MODAL.REGULATORY_COMPLIANCE.DOCUMENTATION_NOTE' | translate }}
        </p>
      </div>
    }
    @default {
      <div>
        <b>SMS Registration Information</b>
        <p>
          Based on your business location, no specific SMS registration is currently required. However, all SMS
          messaging must comply with applicable laws and carrier guidelines.
        </p>
        <b>Best practices for SMS messaging</b>
        <ul>
          <li>Always obtain explicit consent before sending SMS messages</li>
          <li>Provide clear opt-out instructions in every message</li>
          <li>Respect customer preferences and honor opt-out requests immediately</li>
          <li>Keep messages relevant and valuable to recipients</li>
        </ul>
      </div>
    }
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close mat-stroked-button>Close</button>
</mat-dialog-actions>
